import React from "react";
import { SpinnerSize } from "@fluentui/react";
import { PLEASE_WAIT } from "../../redux/constants/messageTypes";
import { useTheme } from "../../theme/OAS365Theme";
import CustomSpinner from "../CustomSpinner";

/**
 * Loading content for dialogs. Uses theme for message color.
 * @param {string} [message] - Optional message; defaults to PLEASE_WAIT
 */
export default function DocumentDetailsLoadingContent({ message }) {
  const theme = useTheme();
  const displayMessage = message ?? PLEASE_WAIT;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        padding: "6px 0",
      }}
    >
      {displayMessage && (
        <span
          style={{
            color: theme.colors.fontColor,
            fontWeight: theme.fontWeight.titleWeight,
          }}
        >
          {displayMessage}
        </span>
      )}
      <CustomSpinner size={SpinnerSize.large} />
    </div>
  );
}
